import { T } from '@deity-io/falcon-i18n';
import React from 'react';
import { Loader } from '@deity-io/falcon-ecommerce-uikit';
import Products from '../Category/Products/Products';
import { useRecommendationsQuarticon } from '../../hooks/useQuarticonHooks';
import '../../renderComponents/ProductsSlider/ProductSlider.scss';

const QuarticonRecommendations = ({ sku, type }) => {
  const {
    recomendations,
    loading,
  } = useRecommendationsQuarticon(sku, type);
  const mergedProducts = recomendations;

  if (loading) {
    return (
        <div className="loader-container">
          <Loader/>;
        </div>
    );
  }

  return (
    <>
      {mergedProducts && mergedProducts.length > 0 && (
        <div className="product__related">
          <h2>
            <T id="product.recommendedProducts" />
          </h2>
          <Products items={mergedProducts} isCategory isQuarticon />
        </div>
      )}
    </>
  );
};

export default QuarticonRecommendations;
